//imports

import { NavigateOptions, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type RedirectProps = NavigateOptions;

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const Redirect = (props: NavigateOptions) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(props);
  }, [navigate, props]);
  return null;
};

export { Redirect };
